// extracted by mini-css-extract-plugin
module.exports = {"contentArea":"ContentArea_contentArea__2pGjy"};